module.exports = __webpack_public_path__ + "staticcomp/img/share.73076b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/4/share.jpg
// module id = aipl
// module chunks = 39